





















import { Component, Vue, Prop, Watch, PropSync, Emit} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import CardTitle from '@/components/common/CardTitle.vue';
import Decisions from '@/store/modules/Decisions';
import Users from '@/store/modules/Users';
import CardDesignPreviewContent from '@/components/apps/CardDesignPreviewContent.vue';
import { Decision } from '@/api/model/Decision';

const userModule = getModule(Users);
const decisionsModule = getModule(Decisions);

@Component({
    name: 'CardDesignPreview',
    components: {
        CardTitle,
        CardDesignPreviewContent
    },
    directives: {},
})
export default class CardDesignPreview extends Vue {
    private show = false;
    
    @Prop({default: false, type: Boolean})
    dialogShow!: boolean;

    @Prop({default:() => { return {}}, type:Object})
    item!: any
    
    @Watch('dialogShow')
    onChangeDialogShow() {
        if(this.dialogShow) {
            this.show = true;
        }
    }

    @Emit('close')
    private close() {
        this.show = false;
    }

}
